import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const AvatarRoot = styled.div<{ $size?: string; $clickable?: boolean }>`
  width: ${(props) => props.$size ?? '2.25rem'};
  height: ${(props) => props.$size ?? '2.25rem'};
  border-radius: 50%;
  overflow: hidden;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.secondary};
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  ${(props) => props.$clickable && 'cursor: pointer;'}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
